import { render, staticRenderFns } from "./PTIActual.vue?vue&type=template&id=1a38322c&scoped=true"
import script from "./PTIActual.vue?vue&type=script&lang=js"
export * from "./PTIActual.vue?vue&type=script&lang=js"
import style0 from "./PTIActual.vue?vue&type=style&index=0&id=1a38322c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38322c",
  null
  
)

export default component.exports